import React, { useEffect } from 'react';
import Table from 'src/components/table/Table';
import FileSaver from 'file-saver';
import { useFetch } from 'src/hooks/useFetch';
import { Modal } from '..';
import LoadingSpinner from 'src/components/LoadingSpinner';

function DescargarArchivosModal(props) {
  const { open, close } = props;
  const { fetch, loading, data } = useFetch();
  const { fetch: fetchFile } = useFetch();

  const isRequerimiento = /^R-\d+$/.test(props?.data?.codigo);

  const onCloseModal = React.useCallback(() => {
    close();
  }, [close]);

  const getArchivosAdjuntos = React.useCallback(() => {
    fetch(
      `/tickets/${isRequerimiento ? 'requerimientos' : 'incidentes'}/${
        props?.data?.codigo
      }/archivos`,
    );
  }, [fetch, props.data.codigo, isRequerimiento]);

  useEffect(() => {
    getArchivosAdjuntos();
  }, [getArchivosAdjuntos]);

  const downloadFile = React.useCallback(
    async (row) => {
      const response = await fetchFile(
        `/tickets/archivos-adjuntos?id_archivo=${row.id}`,
        { responseType: 'blob' },
      );

      FileSaver.saveAs(
        new Blob([response.data], { type: response.headers['content-type'] }),
        row.nombre,
      );
    },
    [fetchFile],
  );

  const downloadZipFile = React.useCallback(async () => {
    const response = await fetchFile(
      `/tickets/archivos-adjuntos/zip?ticket_ref=${props?.data?.codigo}`,
      { responseType: 'blob' },
    );

    FileSaver.saveAs(
      new Blob([response.data], { type: response.headers['content-type'] }),
      `archivos-comprimidos-${props?.data?.codigo}.zip`,
    );
  }, [fetchFile, props?.data?.codigo]);

  const tableHeaders = React.useMemo(
    () => [
      { id: 'nombre', label: 'Nombre' },
      { id: 'fecha', label: 'Fecha' },
    ],
    [],
  );

  const rowActions = React.useMemo(
    () => [
      {
        text: 'Descargar',
        icon: null,
        handler: downloadFile,
      },
    ],
    [downloadFile],
  );

  const customTableActions = [
    {
      text: 'Descargar Todo',
      icon: null,
      handler: downloadZipFile,
    },
  ];

  return (
    <Modal
      title={`Archivos: ${props?.data.codigo}`}
      maxWidth="md"
      cancelButtonPosition="top"
      content={
        loading ? (
          <LoadingSpinner />
        ) : (
          <Table
            tableActions={{
              showDownloadCurrentPageAsExcelDocumentButton: false,
            }}
            customTableActions={customTableActions}
            loading={loading}
            headers={tableHeaders}
            rows={data ?? []}
            rowActions={rowActions}
          />
        )
      }
      open={open}
      close={onCloseModal}
      showConfirmButton={false}
      cancelButtonText="Cerrar"
    />
  );
}

export default DescargarArchivosModal;
